import type { PropsWithChildren } from 'react';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT } from '../../common';
import { Text } from './text';

export function Title({
  children,
  classModifier
}: PropsWithChildren<{ classModifier?: string }>) {
  return (
    <Text
      textStyle={{
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '22px',
        textAlign: 'left'
      }}
      className={createReadableClass({
        component: CLASS_COMPONENT,
        element: 'title-block',
        modifier: classModifier
      })}
    >
      {children}
    </Text>
  );
}
